module.exports = __webpack_public_path__ + "images/illustrations/illustration-rise-blocks@2x-6729baa2b890f91eff2ea747abda42c8.webp";